import { getData, postData, putData, deleteData } from "../apiClient";

const ItemName = "Hall Booking";
const API_URL = "hall-bookings";

// get all with pagination
export const GetAll = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/${API_URL}/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(`Get ${ItemName} with pagination API error:`, error);
    return {
      success: false,
      ...error,
    };
  }
};

export const getExistingCustomer = async ({ inputValue, customerType }) => {
  try {
    const result = await getData(
      `/${API_URL}/customers/${inputValue}/${customerType}`,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// get item data with id
export const GetById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get  ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// get item data with id for view page
export const GetViewHallBookingById = async (id) => {
  try {
    const result = await getData(`/${API_URL}/view-hall-booking/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get View ${ItemName} data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create item
export const Create = async ({ data }) => {
  try {
    const result = await postData(`/${API_URL}/`, data, {
      "Content-Type": "multipart/form-data",
    });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      `Create ${ItemName} API error:`,
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// update item
export const Update = async ({ id, data }) => {
  try {
    const result = await putData(`/${API_URL}/${id}`, data, {
      "Content-Type": "multipart/form-data",
    });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Update ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete item
export const Delete = async ({ id }) => {
  try {
    const result = await deleteData(`/${API_URL}/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(`Delete ${ItemName} API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// --- Hall Booking Module Dependencies ---

export const GetAllHallRoomTypes = async () => {
  try {
    const result = await getData(`/${API_URL}/hall-room-types`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Hall Room Type API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetAllPaymentMethods = async () => {
  try {
    const result = await getData(`/${API_URL}/payment-methods`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Payment Method API error:", error);
    return { data: { success: false, error: error.message } };
  }
};

export const GetAllFoodPackages = async () => {
  try {
    const result = await getData(`/${API_URL}/food-package`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Food Package API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// Get full food package detail (food type limits + food items) by package_id
export const GetFoodPackageDetail = async (packageId) => {
  try {
    const result = await getData(`/${API_URL}/food-package/${packageId}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Food Package Detail API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetAllPFTL = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const result = await getData(`/food-package-limit/?${queryParams}`);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get PFTL API error:", error);
    return { success: false, ...error };
  }
};

export const GetAllFoods = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const result = await getData(`/food-list/?${queryParams}`);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Food API error:", error);
    return { success: false, ...error };
  }
};

export const CheckHallAvailability = async (data) => {
  try {
    const result = await postData(`/${API_URL}/check-hall-availability`, data);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Check Hall Availability API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
        available: false,
      },
    };
  }
};
